import { Tooltip } from '@cian/ui-kit/tooltip';
import React from 'react';

import styles from './FeatureLabel.css';

export interface IFeatureLabel {
  icon: React.ReactNode;
  tooltip: string;
}

export function FeatureLabel({ icon, tooltip }: IFeatureLabel) {
  return (
    <Tooltip title={tooltip} placement="bottom">
      <div className={styles['label']}>{icon}</div>
    </Tooltip>
  );
}
